/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */

// Split out of kHTML.ts 2026-10-19 (owner: smaller units for the reuse reviewer). kHTML.ts
// re-exports kHTMLRow, so `import { kHTMLRow } from "./kHTML"` keeps working.
import ks from "../ReUsableTS/kBrowserShared";
import { kStyleClass, kStyles } from "./kStyles";
import { kHTMLRowCore } from "../kReusableCoreTS/kHTMLCore";

// Extends the server-safe kHTMLRowCore: the cell string model
// (CellModels), escaping and ToHtmlString() live in the base; this
// browser subclass keeps the live-DOM <tr>/<td> construction. `Cells`
// here is the DOM cell list and is distinct from the base's CellModels.
export class kHTMLRow extends kHTMLRowCore {
    public Row: HTMLTableRowElement;
    public Cells: HTMLTableCellElement[] = [];
    public constructor() {
        super();
        this.Row = document.createElement("tr");
        const DefaultRowStyle:kStyleClass = kStyles.AddStyle("kRowDef");
        if(DefaultRowStyle.Saved ===false){
            DefaultRowStyle.Style.verticalAlign = "top";
        }
        DefaultRowStyle.Apply(this.Row);
    }

    public AddCellHTML = (
        Content: string,
        ClassName?: string
    ): HTMLTableCellElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement | null = this.AddCell(
                undefined,
                ClassName
            );
            if (null !== NewCell) {
                NewCell.innerHTML = Content;
                if (null !== this.Row) {
                    this.Row.appendChild(NewCell);
                }
                return NewCell;
            }
            return document.createElement("td");
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.AddCellHTML");
            return document.createElement("td");
        }
    };
    public AddNumberCell = (
        Content?: number,
        ClassName?: string
    ): HTMLTableCellElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("td");
        }
        try {
            if (undefined === Content) {
                Content = 0;
            }
            const NewCell: HTMLTableCellElement | null = this.AddCell(
                Content.toString(),
                ClassName
            );
            if (null !== NewCell) {
                NewCell.style.textAlign = "right";
            }

            return NewCell;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.AddNumberCell");
            return document.createElement("td");
        }
    };
    public AddCell = (
        Content?: string,
        ClassName?: string
    ): HTMLTableCellElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement = this._AddCell();
            if (undefined !== Content) {
                if (null !== NewCell) {
                    NewCell.textContent = Content;
                }
            }
            if (undefined !== ClassName) {
                if (ks.KNotEmptyString(ClassName)) {
                    if (null !== NewCell) {
                        NewCell.className = ClassName;
                    }
                }
            }
            if (null !== this.Row) {
                if (null !== NewCell) {
                    this.Row.appendChild(NewCell);
                }
            }
            return NewCell;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.AddCell");
            return document.createElement("td");
        }
    };
    public AddMergedCell = (Cols: number): HTMLTableCellElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement = document.createElement("td");
            NewCell.colSpan = Cols;
            if (null !== this.Row) {
                this.Row.appendChild(NewCell);
            }
            return NewCell;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.AddMergedCell");
            return document.createElement("td");
        }
    };
    public AddCellFirst = (): HTMLTableCellElement | null => {
        if (ks.KErrorMode === true) {
            return null;
        }
        try {
            const NewCell: HTMLTableCellElement | null = this._AddCell();
            if (this.Row !== null && NewCell !== null) {
                this.Row.insertBefore(NewCell, this.Row.firstChild);
            }
            return NewCell;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.AddCellFirst");
            return null;
        }
    };
    public AddCellWithElement = (Elem: HTMLElement|SVGSVGElement): HTMLTableCellElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("td");
        }
        try {
            if (Elem) {
                const NewCell: HTMLTableCellElement | null = this._AddCell();
                if (null !== NewCell) {
                    NewCell.appendChild(Elem);
                    if (null !== this.Row) {
                        this.Row.appendChild(NewCell);
                    }
                }
                return NewCell;
            } else {
                return document.createElement("td");
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.AddCellWithElement");
            return document.createElement("td");
        }
    };
    public GetCellInnerHTML = (ClassName: string): string => {
        if (ks.KErrorMode === true) {
            return "";
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                return Cell.innerHTML;
            }
            return "";
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCellInnerHTML");
            return "";
        }
    };
    public GetCellTextValue = (ClassName: string): string => {
        if (ks.KErrorMode === true) {
            return "";
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                return ks.Nz(Cell.textContent).trim();
            } else {
                return "";
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCellTextValue");
            return "";
        }
    };

    public GetCells = (): void => {
        if (ks.KErrorMode === true) {
            return;
        }
        try {
            this.Cells = [];
            //var CellObjs: HTMLCollectionOf<HTMLTableCellElement> = this.Row.getElementsByTagName("td");
            if (null !== this.Row) {
                const CellObjs: any = this.Row.getElementsByTagName("td");
                let Counter = 0;
                for (Counter = 0; Counter < CellObjs.length; Counter++) {
                    const CurrCell: HTMLTableCellElement = CellObjs.item(
                        Counter
                    ) as HTMLTableCellElement;
                    if (CurrCell.parentElement === this.Row) {
                        //Only direct decentants
                        this.Cells.push(CurrCell);
                    }
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCells");
        }
    };
    public GetCellByIndex = (Index: number): HTMLTableCellElement | null => {
        if (ks.KErrorMode === true) {
            return null;
        }
        try {
            if (this.Cells.length === 0) {
                this.GetCells();
            }
            if (this.Cells.length >= Index) {
                return this.Cells[Index];
            }
            return null;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCellByIndex");
            return null;
        }
    };
    public GetCellNumberValue = (ClassName: string): number => {
        if (ks.KErrorMode === true) {
            return 0;
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                return parseInt(ks.Nz(Cell.textContent));
            }
            return 0;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCellNumberValue");
            return 0;
        }
    };
    /** Like GetCellNumberValue but parseFloat, so a decimal survives the round-trip.
     *  GetCellNumberValue uses parseInt and therefore truncates - "12.5" reads back as
     *  12. That is correct for counts and silently wrong for money, which is why this
     *  is a SEPARATE method: changing GetCellNumberValue would alter behaviour for
     *  every existing caller in the estate. Use this one for rates/amounts. */
    public GetCellDecimalValue = (ClassName: string): number => {
        if (ks.KErrorMode === true) {
            return 0;
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                const Parsed: number = parseFloat(ks.Nz(Cell.textContent));
                if (isNaN(Parsed)) {
                    return 0;
                }
                return Parsed;
            }
            return 0;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCellDecimalValue");
            return 0;
        }
    };
    public GetCellByClassName = (
        ClassName: string
    ): HTMLTableCellElement | null => {
        if (ks.KErrorMode === true) {
            return null;
        }
        try {
            let Cell: HTMLTableCellElement | null = null;
            if (null !== this.Row) {
                Cell = this.Row.getElementsByClassName(
                    ClassName
                )[0] as HTMLTableCellElement;
            }
            return Cell;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow.GetCellByClassName");
            return null;
        }
    };
    private _AddCell = (): HTMLTableCellElement => {
        if (ks.KErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement = document.createElement("td");
            NewCell.style.verticalAlign = "top";
            return NewCell;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kHTMLRow._AddCell");
            return document.createElement("td");
        }
    };
}
